import { bl_svc_issue_audit_trail_RowClass } from "../../dbschema/bl_svc_issue_audit_trail.model";
import { BaseContainerModel } from "../base-container.model";

export class SvcIssueAuditTrailContainerModel extends BaseContainerModel {
  bl_svc_issue_audit_trail: bl_svc_issue_audit_trail_RowClass = new bl_svc_issue_audit_trail_RowClass();
}